var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MdInputModule, MdIconModule, MdButtonModule } from '@angular/material';
import { TdSearchInputComponent } from './search-input/search-input.component';
import { TdSearchBoxComponent } from './search-box/search-box.component';
export { TdSearchBoxComponent } from './search-box/search-box.component';
export { TdSearchInputComponent } from './search-input/search-input.component';
var CovalentSearchModule = (function () {
    function CovalentSearchModule() {
    }
    return CovalentSearchModule;
}());
CovalentSearchModule = __decorate([
    NgModule({
        imports: [
            FormsModule,
            CommonModule,
            MdInputModule,
            MdIconModule,
            MdButtonModule,
        ],
        declarations: [
            TdSearchInputComponent,
            TdSearchBoxComponent,
        ],
        exports: [
            TdSearchInputComponent,
            TdSearchBoxComponent,
        ],
    })
], CovalentSearchModule);
export { CovalentSearchModule };
//# sourceMappingURL=search.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@covalent/core/search/search.module.js
// module id = ../../../../@covalent/core/search/search.module.js
// module chunks = 4